// extracted by mini-css-extract-plugin
export default {"container":"Form_container__Z6eG3","checkbox":"Form_checkbox__0PO+N"};